import { useNewProjectService } from 'domain/shared/newProject';
import { useShowContext } from 'framework/show';
import { TextField } from 'framework/ui/field';
import { useAsyncValue } from 'framework/utils';

const ProjectNameField = () => {
  const { data } = useShowContext();
  const { getById: getNewProjectById } = useNewProjectService();

  const projectName = useAsyncValue(
    async () =>
      data.relatedProject
        ? getNewProjectById(data.relatedProject).then(project => project?.name)
        : Promise.resolve(null),
    [data.relatedProject],
  );

  if (!projectName) return null;
  return <TextField label="Related Project" value={projectName} />;
};

export default ProjectNameField;
